VegasCatalog.Variants = {
	container: '.list-variant',

	toggle: function ($self) {
		let params = {
			value: $self.data('value'),
			type: $self.data('type'),
			title: $self.data('title') || undefined,
			redirect: $self.data('redirect') || undefined
		}

		let ajax = $self.closest('.variants-area').hasClass('js-ajax');

		if (ajax) {
			let $modal = $self.closest('#modal-product'),
				$target = $modal.find('#modal-product-content'),
				$preload = $modal.find('.modal-preload');

			$preload.fadeIn();

			$.get(params.redirect, {modal: true}, function (data) {
				$target.html('');

				setTimeout(() => {
					$preload.fadeOut();
					$target.html(data.view);

					let $swiper = $target.find('.swiper');
					if ($swiper.length) {
						$swiper.each(function () {
							VGCarousel.init(this);
						});
					}

					let $form = $target.find('[data-vgformsender]');
					if ($form.length) {
						$form.vegasFormSender({
							beforeSend: function (form, params) {
								AlertFormSender.Action.beforeSend(form, params);
							},
							success: function (data, form, params) {
								if (data.error) {
									AlertFormSender.Action.error(data.msg, form, params);
								} else {
									AlertFormSender.Action.success(data.msg, form, params);
								}

							},
							error: function (msg, form, params) {
								AlertFormSender.Action.error(msg, form, params);
							},
							validate: function (form, params, errors) {
								ValidateFormSender.init(errors, form, params);
							}
						});
					}
				}, 500);
			})
		} else {
			if (params.redirect) {
				let redirectTo = params.redirect + '&pos-offset=' + $(window).scrollTop();
				location.href = redirectTo;
			}
		}
	}
}

$(document).on('click', '[data-product] [data-toggle="variant"], #modal-product-content [data-toggle="variant"]', function () {
	if ($(this).hasClass('checked')) return;
	if ($(this).hasClass('disabled')) return;
	VegasCatalog.Variants.toggle($(this));
	return false;
});